export interface ISelectionFilters {
  family: string[];
  status?: string;
}

export type UpdateSelectionFilterPayload = {
  [K in keyof ISelectionFilters]-?: { key: K; value: ISelectionFilters[K] };
}[keyof ISelectionFilters];

export interface FilterStateSelection {
  filters: ISelectionFilters;
}

export const DEFAULT_SELECTION_FILTERS: ISelectionFilters = {
  family: [],
};
